var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedDay,
            expression: "selectedDay",
          },
        ],
        staticClass: "form-select",
        attrs: { title: "Path" },
        on: {
          change: [
            function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.selectedDay = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
            function ($event) {
              return _vm.selectDate()
            },
          ],
        },
      },
      [
        _c("option", { domProps: { value: null } }, [_vm._v("all days")]),
        _vm._v(" "),
        _vm._l(_vm.allDates, function (d) {
          return _c("option", { domProps: { value: d } }, [
            _vm._v(_vm._s(_vm.getCalendarDateName(d))),
          ])
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "clearfix" }),
    _vm._v(" "),
    _c("div", { staticClass: "course-schedules-calendar" }, [
      _vm.dates.length > 0 && _vm.hours.length > 0 && _vm.calendar
        ? _c(
            "div",
            {
              staticClass: "d-flex flex-row flex-nowrap align-content-stretch",
            },
            [
              _c(
                "div",
                { staticClass: "hours flex-shrink-1" },
                [
                  _c("div", { staticClass: "label" }, [_vm._v(" ")]),
                  _vm._v(" "),
                  _vm._l(_vm.hours, function (hour) {
                    return _c("div", { staticClass: "hour" }, [
                      _vm._v("\n          " + _vm._s(hour) + ":00\n        "),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm._l(_vm.dates, function (day) {
                return _c(
                  "div",
                  { staticClass: "day flex-grow-1" },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.getCalendarDateName(day))),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.hours, function (hour) {
                      return _c(
                        "div",
                        {
                          staticClass: "hour",
                          class: {
                            unavailable: !_vm.isEditableHour(day, hour, true),
                          },
                        },
                        [
                          _vm.calendar[day.format("YYYY-M-D")] &&
                          _vm.calendar[day.format("YYYY-M-D")][hour]
                            ? _c(
                                "div",
                                { staticClass: "schedule-wrap" },
                                _vm._l(
                                  _vm.calendar[day.format("YYYY-M-D")][hour],
                                  function (card) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "schedule-card d-flex flex-row align-items-stretch",
                                        style: _vm.cardDimensions(card),
                                        attrs: { id: "schedule_" + card.id },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showScheduleDetails(card)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "card-course d-flex flex-column align-items-stretch flex-fill",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "course flex-fill",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "name" },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        style: {
                                                          color:
                                                            card.course.type
                                                              .color,
                                                        },
                                                        attrs: {
                                                          href: card.course
                                                            .link,
                                                          target: "_blank",
                                                          title:
                                                            card.course.name,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            card.course.name
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    card.type === "wait"
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "small text-muted",
                                                          },
                                                          [_vm._v("[wait]")]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                card.trainer
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "trainer",
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            style: {
                                                              color:
                                                                card.trainer
                                                                  .color,
                                                            },
                                                            attrs: {
                                                              href: card.trainer
                                                                .link,
                                                              target: "_blank",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                card.trainer
                                                                  .name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                card.guest_ids &&
                                                Array.isArray(card.guest_ids)
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          card.guest_ids.length
                                                        ) + " guests"
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "schedule",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showScheduleDetails(
                                                      card
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-calendar-alt float-right",
                                                }),
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.dateFormat(
                                                        card.from,
                                                        "h:mm a"
                                                      )
                                                    ) +
                                                    " - " +
                                                    _vm._s(
                                                      _vm.dateFormat(
                                                        card.till,
                                                        "h:mm a"
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEditableHour(day, hour, true)
                            ? _c("div", { staticClass: "schedule-placement" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "add-schedule",
                                    on: {
                                      click: function ($event) {
                                        return _vm.addSchedule(day, hour)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              add a schedule\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                  ],
                  2
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }